import IndividualDevelopmentPlanApprovalView from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';

export const Modes = {
  APPROVE: 'approve',
  EDIT: 'edit',
  REJECT: 'reject',
};

export default ({ getState }) => ({
  path: ':groupIdpId/dos-approval(/:mode)(/:idpId)',
  component: IndividualDevelopmentPlanApprovalView,
  canAccess: () => PrivilegeChecker.hasPrivilege(
    getState(),
    Privileges.IndividualDevelopmentPlan.ApproveComment
  ),
  tabs: {
    hidden: true,
  },
  sessionNav: {
    hidden: true,
  },
  actionButtons: {
    hidden: true,
  },
  breadcrumbLabels: 'DOS Approval',
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanApprovalView/routes.js